export enum PaymentTypeEnum{
    Cash= 1,
    Wallet=2
}